import { defineStyleConfig } from "@chakra-ui/react";

export const Button = defineStyleConfig({
	defaultProps: {
		colorScheme: "primary",
		size: "lg",
	},
});
